<template>
  <question-base-wrapper
    :question-id="questionId || 'no-claims-bonus'"
    :title="questionLabel"
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ failedRules, errors }"
      :vid="`${stepId}_no-claims-bonus`"
      name="No Claims Bonus"
      :rules="fieldValidationRules"
    >
      <qz-select
        v-model="questionData.noClaimsBonus"
        :data-test="fieldTrackerId"
        :items="noClaimsBonusOptions"
        :error-messages="getFieldErrors('field', failedRules, errors)"
        :placeholder="helpers.getPlaceholderResponsiveText('Please select', isMobile)"
      />
      <help-text
        v-if="isWarningVisible && !errors.length"
        class="mt-4"
      >
        <p><strong><u>Please review:</u></strong> The number of years NCD you selected is greater than your current licence held years. In some circumstances this will be fine (e.g. you’ve earned NCD on a Provisional licence too), though some insurance providers may not return a quote, so please change this if it’s incorrect.</p>
      </help-text>
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import { ExtDate } from '@/helpers/date';
import QuestionBase from './Base';
import HelpText from '@/components/HelpText/HelpText.vue';
import { snakeCase } from 'lodash';

export default {
  name: 'question-no-claim-bonus',
  extends: QuestionBase,
  components: {
    HelpText,
  },
  data () {
    return {
      fields: ['noClaimsBonus'],
    };
  },
  computed: {
    questionLabel () {
      if (this.productName === 'bike') {
        return 'How many years no claims discount (NCD) do you currently have for this bike?';
      }
      if (this.productName === 'van') {
        return 'How many years commercial vehicle no claims discount (NCD) do you have?';
      }
      return 'How many years of no claims discount do you have?';
    },
    noClaimsBonusOptions () {
      return this.helpers.createOptions({
        source: this.constants.COVER_NO_CLAIMS_BONUS,
        asNumbers: true,
      });
    },
    driver () {
      return this.formData.drivers[0];
    },
    yearsOfLicenceHeld () {
      return this.driver.periodOfLicenceHeld ? this.yearsToToday(this.driver.periodOfLicenceHeld) : null;
    },
    isWarningVisible () {
      return this.questionData.noClaimsBonus > this.yearsOfLicenceHeld;
    },
    fieldTrackerId () {
      return snakeCase(this.questionFields.noClaimsBonus);
    },
    fieldValidationRules () {
      if (this.validationRules) {
        return this.helpers.parseRules(this.validationRules?.field, this);
      }
      return 'listOptionRequired';
    },
  },
  methods: {
    yearsToToday (date) {
      return new ExtDate().differenceInYears(new ExtDate(date));
    },
  },
};
</script>
